import client from "../client/client";

class CoverageParagraphService {
	getDeliverablesForProject({ projectId }, cancelToken) {
		return client.get(`/project/${projectId}/coverage-paragraph/coverage-document`, {
			config: { cancelToken },
		});
	}

	getParagraphsOfDeliverableByProject({ projectId, deliverableId }, cancelToken) {
		return client.get(`/project/${projectId}/coverage-paragraph/coverage-document/${deliverableId}`, {
			config: { cancelToken },
		});
	}

	getParagraphOutParentDetails({ projectId, requirementId }, cancelToken) {
		return client.get(`/project/${projectId}/coverage-paragraph/parent-requirement/${requirementId}`, {
			config: { cancelToken },
		});
	}

	getAllCategoriesForParagraphOut({ projectId, paragraphOutId }, { search }, cancelToken) {
		return client.get(`/projects/${projectId}/thematic/coverage_paragraph/${paragraphOutId}`, {
			params: { search },
			config: { cancelToken },
		});
	}

	updateCategoriesForParagraphOut({ projectId, paragraphOutId }, { addThematic, deleteThematic }, cancelToken) {
		return client.post(`/projects/${projectId}/thematic/coverage_paragraph/${paragraphOutId}`, {
			payload: { addThematic, deleteThematic },
			config: { cancelToken },
		});
	}
}

export default new CoverageParagraphService();
